<template>
  <div>
    <h3 class="mb-6">Venue Campaigns</h3>
    <vs-tabs position="left" class="tabs-shadow-none mt-2" id="profile-tabs" :key="isSmallerScreen">
      <vs-tab icon-pack="feather" icon="icon-bold" :label="!isSmallerScreen ? 'Pending campaigns' : ''">
        <div class="lists-view-tab">
          <pending-campaigns />
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-zap" :label="!isSmallerScreen ? 'Completed campaigns' : ''">
        <div class="lists-view-tab">
          <completed-campaigns />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import PendingCampaigns from "./SideMenu/PendingCampaigns.vue";
import CompletedCampaigns from "./SideMenu/CompletedCampaigns.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    PendingCampaigns,
    CompletedCampaigns,
  },
  data() {
    return {};
  },
  async mounted() {},
  methods: {},
  computed: {
    ...mapGetters({
      activeVenue: "users/userId",
    }),
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },
};
</script>

<style lang="scss">
.lists-view-tab {
  margin-left: 12px;
}
</style>
